<template>
    <v-container class="pa-0 ma-0" id="mainhomecontainer">
        <v-card class="overview" elevation="0">
            <v-card-title class="pa-0">
                <v-container style="min-height:200px;" class="topbg">
                <v-row>
                    <v-col
                    cols="12"
                    md="12"
                    color="white--text"
                    class="text-center mt-5 mb-5"
                    style="color:#fff;"
                    >
                    Welcome to Juzzap
                    <br />
                    <span class style="font-size:16px;">A NEW PARADIGM</span>
                    </v-col>
                </v-row>
                </v-container>

                <v-row class="pwa-content">
                <v-col cols="12" md="12" class="text-center">
                    <img :src="juzzapLogo" width="100" />
                </v-col>
                </v-row>

                <!-- <v-img  :src="(storeBusiness.overviewimage=='null' || storeBusiness.overviewimage==null )?bannerImg:storeBusiness.overviewimage " aspect-ratio="1" class="lighten-2 " max-height="287">
                                    <v-row class="fill-height align-center" style="background:rgba(0,0,0, 0.4);">
                                        <v-col cols="12" md="12" sm="12" class="text-center white--text">
                                            <div v-if="storeBusiness.overviewimagetitle=='' || storeBusiness.overviewimagetitle==null">
                                                <h2 class="heading" >{{storeBusiness.businessName}}</h2>
                                                <span class="subtitle-1">{{storeBusiness.addressLine3}} {{storeBusiness.addressLine4}}</span>

                                                <v-row justify="center">

                                                    <v-col cols="12" md="12" sm="12"  align="center" class="text-center">
                                                        <v-icon v-for="n in storeBusiness.starrating" :key="n" color="#FEC83D" >mdi-star</v-icon>

                                                    </v-col>

                                                </v-row>
                                            </div>
                                        <div v-else>
                                            <h2 class="heading" >{{storeBusiness.overviewimagetitle}}</h2>
                                                <span class="subtitle-1 pl-3 pr-3">{{storeBusiness.overviewimagedescription}} </span>
                                        </div>
                                        </v-col>

                                    </v-row>

                </v-img>-->
            </v-card-title>

            <v-card-text>
                <v-container fluid>
                    <v-row>
                        <v-col cols="12" md="12" sm="12" class="text-center ">
                        <h2>Register</h2>
                        </v-col>
                        <v-col cols="12" md="12" sm="12" class="text-center pa-0" style="color:#7697A1;font-size:14px;">
                        ALL ACCOUNTS ARE FREE
                        </v-col>
                    </v-row>
                    <v-row align="" justify="center">
                        <v-col cols="12" sm="8" md="12">
                            <v-card class="" tile flat>

                                <v-row class="pl-2 pr-2">
                                    <v-col cols="12" md="12" class="text-center ">
                                        <v-btn class="primary" large block @click="businessaccount">Business Account</v-btn>

                                    </v-col>
                                </v-row>


<!--
                                <v-row class="pl-2 pr-2">
                                    <v-col cols="12" md="12" class="text-center ">
                                        <v-btn class="primary" large block @click="personalaccount">Personal Account</v-btn>

                                    </v-col>
                                </v-row>

                                <v-row class="pl-2 pr-2">
                                    <v-col cols="12" md="12" class="text-center " style="color:#7697A1;">

                                        Registered Users have access to <br>Specail offers & Discounts <br><span style="font-weight:bold;">Food & Drink</span>
                                    </v-col>
                                </v-row>

                                <v-row class="pl-2 pr-2">
                                    <v-col cols="12" md="12" class="text-center ">
                                        <v-btn color="primary" text @click="review">Enter As Guest</v-btn>

                                    </v-col>
                                </v-row>

                                <v-row>
                                        <v-col cols="12" md="12" class="txt-color text-center">
                                            If you prefer to just view without<br>
                                            Registering or Loggin In, be our Guest
                                        </v-col>
                                    </v-row>-->
                            </v-card>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
        </v-card>
    </v-container>
</template>
<script>
import Vue from 'vue'
import VeeValidate from "vee-validate";

Vue.use(VeeValidate);
export default {
    props: {
    source: String
  },
  data: () => ({
      //juzzapLogo:require('@/assets/juzzap-logo.svg'),
      juzzapLogo: require("@/assets/logo-Copy.png"),

  }),
  methods:
  {
      businessaccount()
      {
          this.$router.push("/businessregister");
      },
      personalaccount()
      {
          this.$router.push("/register");
      }
  },
}
</script>
<style scoped>
.topbg {
  background: #fe5800;
}
.pwa-content {
  margin-top: -63px;
}
.txt-color
{

    color: #7697A1;
}
</style>
